import NodeWaterCooledScrew from './node-water-cooled-screw';

export default NodeWaterCooledScrew;
